export const CLASS_NAMES = {
  MODAL: "js-modal",
  BUTTON: "js-modal-button",
  BACKDROP: "js-backdrop",
};
